export enum AssembleiaPautaStatus {
  Bloqueada = 0,
  Liberada = 1,
  Encerrada = 2
}